import React, { useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useParams } from 'react-router-dom'
import ChatHeader from '../../components/ChatHeader'
import ChatBotScreen from '../../components/ChatBotScreen'
import { StyledLayoutWrapper } from './styled'
import { getIsIframe } from '../../utils/getIsIframe'
import { useAppDispatch } from '../../reducers/hooks'
import { userReducer } from '../../reducers/user/userReducer'

const ChatBotLayout: React.FC = () => {
  const isIframe = getIsIframe()
  const dispatch = useAppDispatch()
  const { token, plid, sessionId } = useParams()

  useEffect(() => {
    if ((token !== undefined && token !== null)) {
      const uid = uuidv4()
      dispatch(userReducer.actions.changeToken(token))
      localStorage.setItem('token', token)
      dispatch(userReducer.actions.changeSessionId(sessionId ?? uid))
      localStorage.setItem('sessionId', sessionId ?? uid)
      if ((plid !== undefined && plid !== null)) {
        dispatch(userReducer.actions.changePlatformId(plid))
        localStorage.setItem('platformId', plid)
        dispatch(userReducer.actions.changePlatform('summit'))
        localStorage.setItem('platform', 'summit')
        dispatch(userReducer.actions.changeBotType('manufacturer'))
        localStorage.setItem('botType', 'manufacturer')
      }
    }
  }, [])

  return (
    <StyledLayoutWrapper>
      {!isIframe &&
      <ChatHeader />
      }
      <ChatBotScreen />
    </StyledLayoutWrapper >
  )
}

export default ChatBotLayout
